import React, { createContext, useContext, useState } from "react";

const SharedContext = createContext();

export const useSharedContext = () => useContext(SharedContext);

export const SharedDataSet = ({ children }) => {
  const [emailValue, setEmailValue] = useState(
    localStorage.getItem("email") === "true" || false
  ); // Replace 'example' with your initial value
  const [notificationValue, setNotificationValue] = useState(
    localStorage.getItem("notification") === "true" || false
  ); // Replace 'example' with your initial value
  const [dataBtn, setDataBtn] = useState(
    parseInt(localStorage.getItem("btnValueCount")) || 0
  );
  const [type, setType] = useState();
  const [activeUser, setActiveUser] = useState();
  const [uploadedImage, setUploadedImage] = useState(localStorage.getItem('uploadImage') || '');

  const updateProfilePicture = (newPictureUrl) => {
    localStorage.setItem('uploadImage', newPictureUrl);
    setUploadedImage(newPictureUrl);
  };

  const updateEmailValue = (newValue) => {
    setEmailValue(newValue);
    localStorage.setItem("email", newValue);
  };
  const updateNotificationValue = (newValue) => {
    setNotificationValue(newValue);
    localStorage.setItem("notification", newValue);
  };
  const updateBtnVal = (newValue) => {
    setDataBtn(newValue);
    localStorage.setItem("btnValueCount", newValue);
  };

  return (
    <SharedContext.Provider
      value={{
        emailValue,
        updateEmailValue,
        notificationValue,
        updateNotificationValue,
        dataBtn,
        updateBtnVal,
        activeUser,
        setActiveUser,
        setType,
        type, 
        uploadedImage,
        updateProfilePicture
      }}
    >
      {children}
    </SharedContext.Provider>
  );
};